<template lang="">
    <div>
        <GmapMap
            :center="{ lat: center.lat, lng: center.lng }"
            :zoom="zoomLevel"
            :options="mapOptions"
            style="width: 100%; height: 500px"
            @tilesloaded="getProvinceData"
            ref="myMapRef"
        >
        </GmapMap>
        <div
            class="map-legend"
            :class="{ closed: isLegendClosed }"
            ref="mapLegend"
        >
            <span class="toggle-legend" @click="toggleLegend">
                <i v-if="isLegendClosed" class="fa fa-caret-right fa-lg"></i>
                <i v-else class="fa fa-caret-left fa-lg"></i>
            </span>
            <template v-if="status == 'all result'">
                <div>
                    <span style="background-color: white"></span> Unpenetrated
                    Province
                </div>
                <div class="mt-3">
                    <span style="background-color: red"></span> Majority
                    Counterfeit
                </div>
                <div class="mt-3">
                    <span style="background-color: green"></span> Majority
                    Genuine
                </div>
            </template>
            <template v-else>
                <div
                    v-for="(legend, index) in masterLegend[status]"
                    :class="{ 'mt-3': index > 0 }"
                >
                    <span :style="{ 'background-color': legend.color }"></span>
                    {{ legend.filter }}
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import * as VueGoogleMaps from "vue2-google-maps";
import { mapState, mapActions } from "vuex";
import axios from "axios";

export default {
    props: ["name", "status", "masterLegend"],
    components: {
        GmapMap: VueGoogleMaps.Map,
    },
    data() {
        return {
            mapOptions: {
                styles: [
                    {
                        featureType: "all",
                        elementType: "all",
                        stylers: [{ visibility: "off" }],
                    },
                    {
                        featureType: "landscape",
                        elementType: "geometry",
                        stylers: [{ visibility: "on" }, { color: "#e3f1f2" }],
                    },
                ],
                mapTypeControl: false,
            },
            isLegendClosed: false,
            provinceKeys: [],
            boundaries: [],
            data: [],
        };
    },
    computed: {
        ...mapState("maps", {
            namaProvinsi: (state) => state.namaProvinsi,
            center: (state) => state.center,
            kodeProvinsi: (state) => state.kodeProvinsi,
            filter: (state) => state.filter,
            zoomLevel: (state) => state.zoomLevel,
        }),
    },
    methods: {
        async getProvinceData() {
            try {
                console.log("Fetching data for province:", this.kodeProvinsi);
                let request = await axios.get(
                    `/dashboard/most-active-region-detail?kode_provinsi=${this.kodeProvinsi}&${this.filter}`
                );
                if (request.status == 200) {
                    console.log("Data received:", request.data.data);
                    this.data = request.data.data;
                    this.onMapReady();
                }
            } catch (error) {
                console.log(error);
            }
        },
        onMapReady() {
            this.$refs.myMapRef.$mapPromise.then((map) => {
                let key = this.provinceKeys.findIndex((testing) =>
                    testing.includes(this.namaProvinsi)
                );
                if (key !== -1) {
                    map.data.addGeoJson(this.boundaries[key]);
                } else {
                    console.error(
                        "Boundary not found for province:",
                        this.namaProvinsi
                    );
                }

                map.data.setStyle((feature) => {
                    let kabkot =
                        feature.getProperty("kabkot") ||
                        feature.getProperty("Ig") ||
                        feature.getProperty("Jg");
                    if (!kabkot) {
                        console.error(
                            "kabkot property is missing for feature:",
                            feature
                        );
                        return {
                            fillColor: "white",
                            strokeColor: "black",
                            strokeWeight: 1,
                            fillOpacity: 1, // Ensure maximum opacity
                        };
                    }

                    let formattedKabkot = kabkot
                        .replace(/kota|kabupaten/g, "")
                        .toLowerCase()
                        .replace(/(^|\s)\S/g, (match) => match.toUpperCase());
                    let selectedData = this.data.find(
                        (x) => x.nama_kabupaten === formattedKabkot
                    );

                    let color = "#ffffff"; // Default color

                    if (this.status === "all result") {
                        if (selectedData) {
                            let total_scan = parseInt(selectedData.total_scan);
                            let percentage = parseFloat(
                                selectedData.percentage
                            );
                            if (total_scan === 0) {
                                color = "white";
                            } else if (percentage >= 50) {
                                color = "green";
                            } else {
                                color = "red";
                            }
                        }
                    } else {
                        let legend = this.masterLegend[this.status];
                        if (selectedData) {
                            let percentage = parseFloat(
                                selectedData.percentage
                            );
                            color = this.getColorForValue(percentage, legend);
                        }
                    }

                    return {
                        fillColor: color,
                        strokeColor: "black",
                        strokeWeight: 1,
                        fillOpacity: 1, // Ensure maximum opacity
                    };
                });

                const infoWindow = new google.maps.InfoWindow();

                map.data.addListener("mouseover", (event) => {
                    let feature = event.feature;
                    let kabkot =
                        feature.getProperty("kabkot") ||
                        feature.getProperty("Ig") ||
                        feature.getProperty("Jg");
                    if (!kabkot) {
                        console.error(
                            "kabkot property is missing for feature:",
                            feature
                        );
                        return;
                    }

                    let formattedKabkot = kabkot
                        .replace(/kota|kabupaten/g, "")
                        .toLowerCase()
                        .replace(/(^|\s)\S/g, (match) => match.toUpperCase());
                    let selectedData = this.data.find(
                        (x) => x.nama_kabupaten === formattedKabkot
                    );

                    let description = "";
                    if (selectedData) {
                        description = `
                    <div class="row" style="min-width:250px;min-height:50px">
                        <div class="col-3" style="display:flex;align-items:center;justify-content:center">
                            <div>
                                <h5>${parseInt(selectedData.percentage)} %</h5>
                            </div>
                        </div>
                        <div class="col-9 pr-3">
                            <h5>${formattedKabkot}</h5>
                            ${
                                selectedData.genuine
                                    ? selectedData.genuine + " Genuine "
                                    : selectedData.counterfeit + " Counterfeit "
                            } out of ${selectedData.total_scan} Scan
                        </div>
                    </div>
                `;
                    } else {
                        description = `
                    <div class="row" style="min-width:250px;min-height:50px">
                        <div class="col-3" style="display:flex;align-items:center;justify-content:center">
                            <div>
                                <h5>0 %</h5>
                            </div>
                        </div>
                        <div class="col-9 pr-3">
                            <h5>${formattedKabkot}</h5>
                        </div>
                    </div>
                `;
                    }

                    infoWindow.setContent(description);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.setOptions({
                        pixelOffset: new google.maps.Size(0, -30),
                    });
                    infoWindow.open(map);
                });

                map.data.addListener("mouseout", (event) => {
                    infoWindow.close();
                });

                const legend = this.$refs.mapLegend;
                map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
                    legend
                );
            });
        },
        toggleLegend() {
            this.isLegendClosed = !this.isLegendClosed;
            console.log("Legend toggled:", this.isLegendClosed);
        },
        getColorForValue(value, legend) {
            for (const item of legend) {
                if (
                    (item.min === undefined || value >= item.min) &&
                    (item.max === undefined || value <= item.max)
                ) {
                    return item.color;
                }
            }
            return null;
        },
        ...mapActions("maps", ["updateIsIndonesia"]),
        updateMapState(newState) {
            this.$store.commit("maps/SET_STATE", newState);
            console.log("Map state updated:", newState);
        },
    },
    created() {
        console.log("Component created, zoom level:", this.zoomLevel);
        if (!this.name) {
            this.updateIsIndonesia(true);
        }
        const requireAssets = require.context(
            "@/assets/provinsi",
            false,
            /\.(json)$/
        );
        console.log("Loaded assets:", requireAssets.keys());
        const batasan = requireAssets.keys().map(requireAssets);
        this.provinceKeys = requireAssets.keys();
        this.boundaries = batasan;
    },
};
</script>

<style>
.map-legend {
    background: white;
    padding: 10px;
    margin: 10px;
    border: 1px solid black;
    position: absolute;
    bottom: 30px !important;
    left: 10px;
    transition: all 0.3s ease;
    width: 200px;
    z-index: 5;
}

.toggle-legend {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    padding: 5px 10px;
    background-color: white;
    border-left: 1px solid black;
    z-index: 10;
}

.map-legend h3,
.map-legend div {
    display: none;
}

.map-legend.closed h3,
.map-legend.closed div {
    display: none;
}

.map-legend:not(.closed) h3,
.map-legend:not(.closed) div {
    display: block;
}

.map-legend.closed {
    width: 30px;
    overflow: visible;
}

.map-legend div span {
    display: inline-block;
    width: 15px;
    height: 15px;
    margin-right: 5px;
    vertical-align: middle;
    border: 1px solid black;
}

.map-legend div:nth-child(1) span {
    background-color: white;
}

.map-legend div:nth-child(2) span {
    background-color: red;
}

.map-legend div:nth-child(3) span {
    background-color: green;
}
</style>
